export default __webpack_public_path__ + "static/media/zbyg.896edcf9.png";